
<template>
  <div>
    <IKFiltroFuncionario ref="ikFiltroFuncionario"/> 
    <h6 class="p-text-bold p-mt-5">Limte de horas</h6>
    <div class="p-formgroup-inline">
        <div class="p-field-radiobutton">
            <RadioButton name="opcaoLimiteHE" :value="1" v-model.number="opcaoLimiteHE"/>
            <label>Menor ou igual a 2h</label>
        </div>
        <div class="p-field-radiobutton">
            <RadioButton name="opcaoLimiteHE" :value="2" v-model.number="opcaoLimiteHE"/>
            <label>Maior que 2h</label>
        </div>
    </div>  
    <h6 class="p-text-bold">Período</h6>  
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">
            <label>Dia início</label>
            <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
        </div>
        <div class="p-field p-col">
            <label>Dia final</label>
            <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
        </div>
    </div>
    <Button label="Gerar PDF" icon="pi pi-file-pdf" class="p-mt-3" @click="exportarPdf"/>
  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
import { exibirMensagem, exibirMensagemSis, preViewArquivo, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    relatorioService: null,
    data() {
        return {           
            opcaoLimiteHE: 1,
            dataInicio: new Date(),
            dataFinal: new Date(),
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        exportarPdf() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {              
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                opcaoLimiteHE: this.opcaoLimiteHE,
                idsFuncionarios: idsFuncionarios,
                ativo: dados.ativo,
                cnpj: {...dados.cnpj},
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.exportarHorasExtrasAnalitico(requisicao)
            .then(resp => {     
                preViewArquivo(resp.data);             
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });
        },
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		}
    },
    created() {
        this.relatorioService = new RelatorioService();
    },
    components: {
        'IKFiltroFuncionario': IKFiltroFuncionario,
    }
}
</script>

<style>

</style>